import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'

import {LunaConfirm} from '../widgets/lunaconfirm.component'


const HOVER_OFFSET_X = 27
const HOVER_OFFSET_Y = 20
const MAX_USER_DISPLAY = 3

export class Leg extends React.Component {
    constructor(props) {
        super(props)

        // TODO: Replace with actual users on this leg
        this.state = {
        }

        _.bindAll(this,
            'quickCollabsLayout',
            'quickCollabsShow',
            'quickCollabsHide',
            'onDeleteLeg'
        )
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.isActive !== this.props.isActive || 
      this.props.leg.getIn(['properties', 'start']) !== prevProps.leg.getIn(['properties', 'start']) ||
      this.props.leg.getIn(['properties', 'end']) !== prevProps.leg.getIn(['properties', 'end']) ||
      this.props.leg.getIn(['properties', 'length']) !== prevProps.leg.getIn(['properties', 'length'])
        ) {
            this.props.quicktoolsEvents.hide()
        }
    }

    onDeleteLeg() {
    // if(confirm('Are you sure you want to delete this destination?')){
        this.quickCollabsHide()
        this.props.onDeleteLeg(this.props.leg)
        // evt.stopPropagation()
    // }
    }

    quickCollabsLayout() {
        if (this.props.activeUsers.count() == 0) {
            return ''
        } else {
            if (this.props.activeUsers.count() > MAX_USER_DISPLAY) {
                return (
                    <div className="leg-collabs-container">
                        <i className="icon-profile"/>
                    </div>
                )
            } else {
                // TODO: Trim user name to first chars of first and last name if possible. Need actual user object to test
                let users = this.props.activeUsers.map((presenceData, clientId) => {
                    let nameParts = presenceData.get('name').split(' ').slice(0, 2)
                    let initials = _.map(nameParts, (namePart) => namePart[0].toUpperCase()).join('')

                    if (nameParts[0] == 'LUNA' && nameParts[1] == 'PLANNER') {
                        return (
                            <div>
                                <i className="icon-diamond" style={{fontSize: '1.5em'}}/>
                            </div>
                        )
                    } else {
                        return (
                            <div
                  data-name={presenceData.get('name')}
                  className="user-icon"
                  key={clientId}>
                                {initials}
                            </div>
                        )
                    }
                })

                return (
                    <div className="leg-collabs-container">
                        { users }
                    </div>
                )
            }
        }
    }

    quickCollabsShow(evt) {
        let targetRect = evt.target.getBoundingClientRect()
        let targetX = targetRect.left + HOVER_OFFSET_X + 2// slightly different for collabs flyout
        let targetY = targetRect.top + HOVER_OFFSET_Y + 2

        this.props.quicktoolsEvents.hide()// TODO: not sure if there's a better way to do this but make sure quicktools turns off if on
        if (this.props.activeUsers.count() > MAX_USER_DISPLAY) {
            let names = this.props.activeUsers.map((presence) => presence.get('name')).toJS()
            this.props.quickcollabsEvents.show(this.props.leg, targetX, targetY, names)// send all users
        } else {
            let curUser = [evt.target.dataset.name]
            this.props.quickcollabsEvents.show(this.props.leg, targetX, targetY, [curUser])// just send one
        }
    }

    quickCollabsHide() {
        this.props.quickcollabsEvents.hide()
    }

    render() {
        let days = this.props.leg.getIn(['properties', 'length'])
        let start = this.props.leg.getIn(['properties', 'start'])
        let end = this.props.leg.getIn(['properties', 'end'])
        let nights = _.max([days - 1, 0])

        let legClasses = classNames(
            'leg',
            {active: this.props.isActive}
        )

        let activateFn = () => {
            if (this.props.isActive) {
                this.props.onActivateLeg(null)
            } else {
                this.props.onActivateLeg(this.props.leg)
            }
        }

        let quickToolsShow = (evt) => {
            let targetRect = evt.target.getBoundingClientRect()
            let targetX = targetRect.left - (evt.target.parentNode.parentNode.getBoundingClientRect().width / 2) + HOVER_OFFSET_X
            let targetY = targetRect.top + HOVER_OFFSET_Y

            // let targetX = targetRect.left + HOVER_OFFSET_X;
            // let targetY = targetRect.top + HOVER_OFFSET_Y;

            this.props.quickcollabsEvents.hide()
            this.props.quicktoolsEvents.show(this.props.leg, targetX, targetY)
        }

        let quickCollabsLayout = this.quickCollabsLayout()

        let defaultTitle = <i className="icon-location_a"/>

        let displayTitle = ''
        if (this.props.leg.getIn(['destination', 'hasLocation'])) {
            displayTitle = this.props.leg.getIn(['destination', 'title'])
        } else {
            displayTitle = defaultTitle
        }

        return (
            <div className={ legClasses }>
                <div className="leg-handle"/>
                <div className="leg-handle"/>
                <div className="travel-time-band"/>
                <div className="travel-time-band"/>
                <div className="leg-delete">
                    <LunaConfirm type="iconDelete" onConfirm={() => { this.onDeleteLeg() }} mssg="Are you sure you want to delete this leg?"/>                                 
                </div>
                <div className="leg-hover">
                    <div
            className="leg-hover-icon"
            onClick={(evt) => {quickToolsShow(evt)} }>
                        <i className="icon-chat"/></div>
          
                </div>
                <div className="leg-details" onClick={ activateFn } >          
                    <h2>{ displayTitle }</h2>
                    {/* <div className="leg-icons">
            <div className="days-nights">
              {days}&nbsp;&nbsp;<i className="icon-days" aria-hidden="true"></i>
              &nbsp;&nbsp;{nights} <i className="icon-nights" aria-hidden="true"></i>
            </div>
            <div className="travel-icon">
              <i className="fa fa-plane" aria-hidden="true"></i> {days}
            </div>-->
          </div>*/}
                </div>
                { quickCollabsLayout }
            </div>
        )
    }
}
